import { readableDate } from '@lib/common';
import { Typography, TypographyProps } from '@material-ui/core';
import {
  differenceInSeconds,
  differenceInDays,
  differenceInMinutes,
  formatDistance,
  format,
} from 'date-fns';
import { times } from 'lodash';
import { useState, useEffect } from 'react';

interface TimeAgo {
  <C extends React.ElementType>(
    props: TypographyProps<C, { component?: C }> & {
      time: Date;
      breakLine?: boolean;
      dateFirst?: boolean;
    }
  ): JSX.Element;
}

export const TimeAgo: TimeAgo = ({
  time,
  style,
  breakLine = false,
  dateFirst = false,
  ...props
}) => {
  let userTimezoneOffset = time.getTimezoneOffset() * 60000;
  time = new Date(time.getTime() + userTimezoneOffset);
  let current_time = new Date(Date.now() + userTimezoneOffset);
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    const differenceInSecondsForUpdation = Math.abs(differenceInSeconds(time, current_time));

    if (differenceInSecondsForUpdation <= 1800) {
      const interval = setTimeout(() => {
        setCounter(c => c + 1);
      }, 10000);

      return () => clearTimeout(interval);
    }
  }, [counter]);

  const showDistance = Math.abs(differenceInMinutes(time, current_time)) <= 60;

  const [datePart1, datePart2] = dateFirst
    ? ([readableDate(time), format(time, 'hh:mm aa')] as const)
    : ([format(time, 'hh:mm aa'), readableDate(time)] as const);

  return (
    <Typography
      variant="body2"
      color="textSecondary"
      style={{
        fontWeight: 500,
        fontSize: '.755rem',
        // textAlign: 'center',
        lineHeight: 'normal',
        ...style,
      }}
      {...props}>
      {showDistance ? (
        formatDistance(time, current_time, { addSuffix: true, includeSeconds: true })
      ) : (
        <>
          {datePart1}
          {breakLine ? <br /> : <>,&nbsp;</>}
          {datePart2}
        </>
      )}
    </Typography>
  );
};
